import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <rect fillRule="nonzero" x="0" y="0" width="16" height="16"></rect>
          <g
            opacity="0.839999974"
            transform="translate(2.000000, 3.000000)"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <polygon points="12 0 0 0 4.8 5.78111111 4.8 9.77777778 7.2 11 7.2 5.78111111" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
